const CONFIG = {
  BASE_URL: 'https://3d-configurator.davidebalice.dev/'
  //BASE_URL: 'http://localhost:3000/'
}

export default CONFIG
